/**
 * Shared behaviour for every instance of snippets/collection-description-readmore.liquid
 * (collection pages, collection list tiles, rich-text blocks...).
 *
 * The description is always rendered as full HTML and only visually clamped
 * with CSS (line-clamp), so bold/italic/links are never stripped — this
 * script just reveals the "Lire plus" link when a block's content actually
 * overflows its clamp, and removes the clamp on click.
 */
function initCollectionDescReadMore(root) {
  (root || document).querySelectorAll('.collection-desc-wrap').forEach(function (wrap) {
    var content = wrap.querySelector('.collection-desc-content');
    var toggle = wrap.querySelector('.collection-desc-toggle');
    if (!content || !toggle || wrap.dataset.readMoreReady) return;
    wrap.dataset.readMoreReady = 'true';

    if (content.scrollHeight > content.clientHeight + 1) {
      toggle.hidden = false;
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      content.classList.remove('is-clamped');
      toggle.hidden = true;
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCollectionDescReadMore(document);
});

// Content swapped in later (ajax filtering, section re-renders, etc.)
new MutationObserver(function () {
  initCollectionDescReadMore(document);
}).observe(document.body, { childList: true, subtree: true });
